export default __webpack_public_path__ + "static/media/Denoo.6ed133e9.png";